import React from 'react'
import { connect } from 'react-redux'

import { chatIsPendingSelector, sortedUserRoomIdsSelector } from 'selectors'

import Chat from './LargeChat'
import withSpinner from 'components/withSpinner'

class ChatWrapper extends React.Component {
  componentDidMount() {
    if (
      this.props.history.location.pathname.startsWith('/chat') &&
      !this.activeRoom() &&
      this.props.roomIds.length > 0
    ) {
      this.props.history.replace(`/chat/${this.props.roomIds[0]}`)
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.history.location.pathname.startsWith('/chat') &&
      !this.activeRoom() &&
      this.props.roomIds.length > 0
    ) {
      this.props.history.replace(`/chat/${this.props.roomIds[0]}`)
    }
  }

  activeRoom = () => {
    const split = this.props.history.location.pathname.split('/')
    if (split.length >= 2) return split[2]
  }

  render() {
    return (
      <Chat
        roomIds={this.props.roomIds}
        activeRoom={this.activeRoom()}
        selectRoom={activeRoom =>
          this.props.history.push(`/chat/${activeRoom}`)
        }
      />
    )
  }
}

const mapStateToProps = state => ({
  roomIds: sortedUserRoomIdsSelector(state) || [],
})

export default withSpinner(
  chatIsPendingSelector,
  connect(mapStateToProps)(ChatWrapper)
)



// WEBPACK FOOTER //
// ./src/pages/Chat/LargeChatWrapper.js